import { Button } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { Category, Document } from 'interfaces/documents';
import { useAppDispatch } from 'utilities/hooks';
import { isCategory, isDocument } from '../../../utilities/constants';
import { containingFoldersOf } from 'utilities/documentTree';
import { restoreDeletedCategory } from 'slices/categoriesActions';
import { fetchDeletedDocuments, restoreDeletedDocument, refreshDocumentTreeLevels } from 'slices/documentsActions';

interface DocumentsToolbarButtonRestoreProps {
    selected: (Category | Document)[];
    isDisable: boolean;
}

export const DocumentsToolbarButtonRestore: React.FC<DocumentsToolbarButtonRestoreProps> = ({
    selected,
    isDisable,
}) => {
    const dispatch = useAppDispatch();
    const { openModal: openConfirmationRestoreModal } = useModal();

    const handleConfirmRestore = () => {
        handleRestore();
    };

    const handleRestore = async () => {
        const promises = selected.map((item: Category | Document) => {
            if (isCategory(item)) {
                return dispatch(restoreDeletedCategory(item.id));
            } else if (isDocument(item)) {
                return dispatch(restoreDeletedDocument(item.id));
            }
            return null;
        });

        try {
            await Promise.all(promises);
            // Restored items reappear in the folders they were deleted from.
            dispatch(refreshDocumentTreeLevels(containingFoldersOf(selected)));
            dispatch(fetchDeletedDocuments());
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Button
            type="text"
            disabled={isDisable}
            icon={<RollbackOutlined />}
            onClick={() => {
                openConfirmationRestoreModal(
                    'confirmationModal',
                    {
                        text: 'Are you sure want you to restore selected item(s)?',
                    },
                    {
                        onConfirm: handleConfirmRestore,
                    },
                );
            }}
        >
            Restore
        </Button>
    );
};
